import styled from "styled-components";

const HistoryContainer = styled.div`
    padding: 0.5rem;
    overflow-y: auto;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    scrollbar-width: thin;
    scroll-margin-left: 0.5rem;
    scrollbar-color: ${props => props.theme.colors.thumbGray} ${props => props.theme.colors.highClearGray};
`;

const HistoryText = styled.p`
    margin: 0;
    color: ${props => props.theme.colors.black};
    font-size: clamp(0.75rem, 2.5vw, 0.875rem);
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const HistoryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 0 8px;
    border-radius: 8px;
    background: transparent;
    min-height: 33px;
    gap: 8px;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${props => props.theme.colors.silverGrayThree};
    }
    
    &.active {
        background-color: ${props => props.theme.colors.white};
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        
        ${HistoryText} {
            font-weight: 500;
        }
    }
`;

const HistoryAgentDateContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
`;

const EmptyHistoryMessage = styled.div`
    text-align: center;
    padding: 1rem;
    color: ${props => props.theme.colors.darkGray};
    font-size: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

const HistoryAgentNameAndDate = styled.span`
    font-weight: 400;
    font-size: 12px;
`;

const HistoryAgentSeparator = styled.div`
    width: 7px;
    height: 7px;
    background-color: ${props => props.theme.colors.lighterGray};
    border-radius: 50%;
`;

const GroupTitle = styled.h4`
    font-size: 14px;
    font-weight: 600;
    color: ${props => props.theme.colors.black};
    margin: 16px 0 8px 0px;
    
    &:first-child {
        margin-top: 0;
    }
`;

const ConversationGroup = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
`;

const LoadingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
`;

export {
    HistoryContainer,
    HistoryText,
    HistoryWrapper,
    HistoryAgentDateContainer,
    EmptyHistoryMessage,
    HistoryAgentNameAndDate,
    HistoryAgentSeparator,
    GroupTitle,
    ConversationGroup,
    LoadingContainer
}; 